import { useNavigate } from "react-router-dom";
import ErrorView from "../error/errorView";

const NotFoundLayout = () => {
    const navigate = useNavigate();

    return (
        <>
            <ErrorView 
                icon="/images/404.png"
                errorTitle="Oops! This page doesn’t exist."
                errorDescription="Don’t worry, you can go back or check out your past tours instead."
                actionTxt="My Saved Records"
                action={() => navigate('/records')}
            />
        </>
    );
}

export default NotFoundLayout;